import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import { useAttendantsListQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';
import { formatFullName } from 'src/common/util/formatFullName';

export function AttendantSelectionField({
  onlySchedulable,
}: {
  onlySchedulable?: boolean;
}) {
  const { data: attendantsData } = useAttendantsListQuery({
    canBeScheduled: onlySchedulable,
  });
  return (
    <div>
      <FormFieldController name="attendants">
        {({ field, fieldState }) => {
          return (
            <DefaultFormFieldLayout
              label="Attendants"
              error={fieldState.error?.message?.toString()}
              inputId="attendants-id"
            >
              <MultiSelect
                placeholder="Select attendants"
                selected={field.value}
                options={
                  attendantsData?.results.map((attendant) => {
                    return {
                      label: formatFullName(attendant),
                      value: attendant.id || '',
                    };
                  }) || []
                }
                onChange={field.onChange}
              />
            </DefaultFormFieldLayout>
          );
        }}
      </FormFieldController>
    </div>
  );
}
